import React from 'react';
import PropTypes from 'prop-types';
import User from 'components/classes/User';
import MaterialIcon from 'components/common/MaterialIcon';
import { Menu, Button, Tooltip, Modal } from 'antd';
import { setSearchValue, indexUsers as index, indexUsersDeleted as indexDeleted, destroyUser as destroy, restoreUser as restore } from '../Module';

@autobind
/**
 *
 */
export default class List extends User.List {
  static propTypes = Object.assign({}, User.List.propTypes, {
    onAdd: PropTypes.func,
    onView: PropTypes.func,
    deletable: PropTypes.bool,
    component: PropTypes.string, // sheep shit
  });

  static defaultProps = Object.assign({}, User.List.defaultProps, {
    deletable: true,
  });

  /**
   *
   * @param  {Object} props
   */
  constructor(props) {
    super(props);

    this.state = Object.assign({}, this.state, {
      deleted: false,
      search: app.state.Basic.Personnel.searchValue,
    });
  }

  /**
   *
   */
  componentDidMount() {
    this.unsubscribe = app.subscribe(() => this.forceUpdate());
    this._list.resetSearch(this.state.search);

    if (this._users.length === 0 && this.state.search === '') {
      this._onReload(undefined, undefined, true);
    } else {
      this._loaded();
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();

    this.unsubscribe();
  }

  /**
   *
   * @return {Array}
   */
  get _users() {
    return app.state.Basic.Personnel.users;
  }

  /**
   *
   * @return {Object}
   */
  get _pagination() {
    // if(this.state.selectedOnly) return false
    return {
      ...app.state.Basic.Personnel.pagination,
      onChange: (page, limit) => this._onReload(page, limit),
      onShowSizeChange: (page, limit) => this._onReload(page, limit),
    };
  }

  /**
   * renders extra for list
   * @function _renderExtra
   * @return {XML}
   * @private
   */
  get _extra() {
    const { loading, deleted } = this.state;
    const { onAdd } = this.props;
    const pagination = app.state.Basic.Personnel.pagination;

    return (
      <Button.Group>
        <Tooltip title={app.translate('main.Reload')} placement="bottom">
          <Button
            type="dashed"
            onClick={() => this._onReload(pagination.current, pagination.pageSize, true)}
            disabled={!app.can('User@index') || loading}
          >
            <MaterialIcon name="reload" spin={loading} />
          </Button>
        </Tooltip>
        { app.can('User@index') && deleted &&
          <Button
            type="primary"
            onClick={() => this.setState({deleted: false}, () => this._onReload(pagination.current, pagination.pageSize, true))}
            disabled={!app.can('User@index') || loading}
          >
            <MaterialIcon name="format-list-bulleted"/>
          </Button>
        }
        { app.can('User@getDeletedUsers') && !deleted &&
           <Button
             type={'danger'}
             onClick={()=> this.setState({deleted: true},() => this._onReload(pagination.current, pagination.pageSize, true))}
             disabled={!app.can('User@index') || loading}
           >
             <MaterialIcon name="delete"/>
           </Button>
        }
        { !deleted &&
          onAdd &&
          <Button
            type="primary"
            icon="plus"
            onClick={onAdd}
            disabled={!app.can('User@store')}
          >
            {app.translate('main.Add')}
          </Button>
        }
      </Button.Group>
    );
  }

  /**
   *
   */
  _resetSearch() {
    this.setState({ search: '' }, () => {
      this._list.resetSearch();
      app.dispatch(setSearchValue());
    });
  }

  /**
   * reloading all devices data including connection status
   * @param {Number} [page=1]
   * @param {Number} [limit=app.config.pagination.limit]
   * @param {Boolean} [force=false]
   * @private
   */
  _onReload(page = 1, limit = app.config.pagination.limit, force = false) {
    this._load(() => {
      let params = {
        includes: [
          'profile',
        ],
        page: page - 1,
        limit,
      };

      if (force) {
        if (!app._.isEmpty(this.state.search)) params.page = 0;
        this._resetSearch();
      } else {
        params.filterGroups = [{
          filters: [{
            key: this.state.deleted ? 'trashSearch' : 'search',
            value: this.state.search,
            operator: 'ct',
          }],
        }];
      }
      if(this.state.deleted) {
        app.dispatch(indexDeleted(params, this._loaded, this.props.component));
      } else {
        app.dispatch(index(params, this._loaded, this.props.component));
      }
    });
  }

  /**
   *
   * @param {String} value
   * @private
   */
  _onSearch(value) {
    this._load(() => this.setState({ search: value }, () => {
      let params = {
        includes: [
          'profile',
        ],
        filterGroups: [{
          filters: [{
            key: this.state.deleted ? 'trashSearch' : 'search',
            value,
            operator: 'eq',
          }],
        }],
        limit: app.state.Basic.Personnel.pagination.pageSize,
      };

      if(this.state.deleted) {
        app.dispatch(indexDeleted(params, (...res) => {
          this._loaded(...res);
          app.dispatch(setSearchValue(value));
        }));
      } else {
        app.dispatch(index(params, (...res) => {
          this._loaded(...res);
          app.dispatch(setSearchValue(value));
        }));
      }
    }));
  }

  _title(){
    return this.state.deleted ? app.translate('routes.home.basic.personnel.Personnel Deleted') : app.translate('components.classes.user.Personnel');
  }

  /**
   *
   * @param {Object} item
   * @private
   */
  _onRestore(item) {
    Modal.confirm({
      title: app.translate('routes.home.basic.personnel.Restoring person'),
      content: app.translate('routes.home.basic.personnel.Are you sure restoring person with name', { name: `${item.profile.firstName} ${item.profile.lastName}` }),
      onOk: () => app.dispatch(restore(item.id)),
    });
  }

  /**
   *
   * @param {Object} item
   * @private
   */
  _onDelete(item) {
    Modal.confirm({
      title: app.translate('routes.home.basic.personnel.Removing person'),
      content: app.translate('routes.home.basic.personnel.Are you sure removing person with name', { name: `${item.profile.firstName} ${item.profile.lastName}` }),
      onOk: () => app.dispatch(destroy(item.id)),
    });
  }

  /**
   *
   * @param {Object} item
   * @return {XML}
   * @private
   */
  _menu(item) {
    const { onView, deletable } = this.props;
    const { deleted } = this.state;
    let _items = [];

    if (onView && !deleted) {
      _items.push(
        <Menu.Item key="view" disabled={!app.can('User@index')}>
          <MaterialIcon name="eye" />
          {app.translate('main.View')}
        </Menu.Item>
      );
    }

    if (deletable && this._onDelete && !deleted) {
      _items.push(
        <Menu.Item key="delete" disabled={item.id === app.state.Auth.currentUser.id || !app.can('User@destroy')}>
          <MaterialIcon name="delete" />
          {app.translate('main.Delete')}
        </Menu.Item>
      );
    }
    if (deleted && app.can('User@restoreDeletedUser')) {
      _items.push(
        <Menu.Item key="restore">
          <MaterialIcon name="share" />
          {app.translate('main.Restore')}
        </Menu.Item>
      );
    }

    if (_items.length === 0) {
      return null;
    }

    return (
      <Menu
        onClick={({ key }) => {
          switch (key) {
            case 'restore':
              this._onRestore(item);
              break;
            case 'view':
              onView(item);
              break;
            case 'delete':
            default:
              this._onDelete(item);
          }
        }}
      >
        {_items}
      </Menu>
    );
  }
}
